import { ReactComponent as VRHeadset } from 'assets/images/VR_headset.svg'
import { ReactComponent as EyeTracking } from 'assets/images/eye_tracking.svg'
import { ReactComponent as HandTracking } from 'assets/images/hand_tracking.svg'
import { ReactComponent as MRCameras } from 'assets/images/MR_cameras.svg'
import { ReactComponent as One } from 'assets/images/number_1.svg'
import { ReactComponent as Two } from 'assets/images/number_2.svg'
import { ReactComponent as Three } from 'assets/images/number_3.svg'
import { ReactComponent as Four } from 'assets/images/number_4.svg'
import { ReactComponent as One_Gray } from 'assets/images/number_1_gray.svg'
import { ReactComponent as Two_Gray } from 'assets/images/number_2_gray.svg'
import { ReactComponent as Three_Gray } from 'assets/images/number_3_gray.svg'
import { ReactComponent as Four_Gray } from 'assets/images/number_4_gray.svg'

export enum HeadsetVariantType {
  VR_Headset,
  Eye_Tracking,
  Hand_Tracking,
  MR_Cameras
}

// <br/><br/>
export const getHeadsetVariantInfo = (type: HeadsetVariantType) => {
  switch (type) {
    case HeadsetVariantType.VR_Headset:
      return {
        icons: [<VRHeadset/>],
        variantNumber: <One/>,
        variantNumberGrey: <One_Gray/>,
        key: HeadsetVariantType.VR_Headset,
        title: 'Just a VR Headset:',
        titleButton: 'VR Headset',
        description: <span>Step into the mesmerizing world of virtual reality with the VR1 headset. Elevate your entertainment experience, basking in vivid visuals and a vast field of view, courtesy of a unique dual-aspheric lens setup for each eye.<br/><br/>Discover Virtual Reality with the sleekest incarnation of the Somnium VR1 headset, characterized by its minimalistic design and light weight.</span>
      }
    case HeadsetVariantType.Eye_Tracking:
      return {
        icons: [<VRHeadset/>, <EyeTracking/>],
        variantNumber: <Two/>,
        variantNumberGrey: <Two_Gray/>,
        key: HeadsetVariantType.Eye_Tracking,
        title: 'VR Headset\nEye Tracking:',
        titleButton: 'VR Headset + Eye Tracking',
        description: <span>Experience a revolution in virtual reality with the VR1 headset featuring cutting-edge eye tracking technology. As your gaze meets technology, a new world of enhanced performance and interactivity unfolds.<br/><br/>Your eyes guide your interactions, making every moment natural and intuitive. Prepare to be amazed by top-tier performance and unparalleled visuals, made possible by foveated rendering.</span>
      }
    case HeadsetVariantType.Hand_Tracking:
      return {
        icons: [<VRHeadset/>, <EyeTracking/>, <HandTracking/>],
        variantNumber: <Three/>,
        variantNumberGrey: <Three_Gray/>,
        key: HeadsetVariantType.Hand_Tracking,
        title: 'VR Headset\nEye & Hand Tracking:',
        titleButton: 'VR Headset + Eye Tracking\n& Hand Tracking',
        description:
          <span>Unlock the true potential of virtual reality with the VR1 headset that combines eye and hand tracking technologies. Your interactions become seamless and immersive as your hands and gaze merge in the virtual realm.<br/><br/>With the power of your hands and the precision of your gaze, you'll navigate, create, and engage like never before.</span>
      }
    case HeadsetVariantType.MR_Cameras:
      return {
        icons: [<VRHeadset/>, <EyeTracking/>, <HandTracking/>, <MRCameras/>],
        variantNumber: <Four/>,
        variantNumberGrey: <Four_Gray/>,
        key: HeadsetVariantType.MR_Cameras,
        title: 'VR Headset\nEye & Hand Tracking\nMixed Reality Cameras:',
        titleButton: 'VR + Eye & Hand Tracking\nMixed Reality Cameras',
        description:
          <span>Meet the ultimate VR1 headset, featuring eye and hand tracking, mixed reality cameras accompanied with stunning visuals and field of view!<br/><br/>This advanced combination delivers an absolute pinnacle of VR hardware available today. Future-proof your development and gaming endeavors with the most advanced and open PCVR headset on the market.</span>
      }
  }
}
